import { render, staticRenderFns } from "./base-dropdown.vue?vue&type=template&id=51aed093&scoped=true"
import script from "./base-dropdown.vue?vue&type=script&lang=ts"
export * from "./base-dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aed093",
  null
  
)

export default component.exports